module.exports = __webpack_public_path__ + "static/media/perche-5.25edd13a.svg";